import { compact } from '@lglp/utils';
import moment from 'moment';

import { DocumentType } from '../../types/document';
import { and, attr, period } from '../algolia/algolia-filters-builder';

export const searchHubActualites = ({
  hitsPerPage = 10,
  region = [],
  thematic = [],
  category = [],
  dateRange: [startDate, endDate] = [],
  onHome = false,
  hotTopic = false,
}: SearchHubActualitesProps): SearchHubReturnProps => {
  return compact<SearchHubReturnProps>({
    hitsPerPage,
    facets: ['filters.region', 'filters.thematic', 'filters.category'],
    facetFilters: {
      region: region,
      thematic,
      category,
    },
    filters: and(
      [
        // Filters cold articles
        hotTopic && attr('hotTopic', true),
        onHome && attr('onHome', true),
        attr('type', DocumentType.HOT_ARTICLE),
        period(
          'createdAt',
          startDate || moment('19700101', 'YYYYMMDD').valueOf(),
          endDate || moment.now()
        ),
      ].filter(Boolean) as string[]
    ),
  });
};

type SearchHubActualitesProps = {
  hitsPerPage: number;
  region: string[];
  thematic: string[];
  category: string[];
  dateRange: number[];
  onHome: boolean;
  hotTopic: boolean;
};

type SearchHubReturnProps = {
  hitsPerPage: number;
  facets: string[];
  facetFilters: Record<string, any>;
  filters: string;
};
